import React from 'react';
import propTypes from 'prop-types';
import { getCompany } from 'helpers/getCompanyVariables';
import {
  FormControl,
  FormControlLabel,
  Radio,
  RadioGroup,
  Stack
} from '@mui/material';
import { TRANSFER_OPTIONS, TRANSFER_TYPES } from 'constants/enum';
import AutocompleteInput from 'components/Autocomplete/AutocompleteInput';
import companyNames from 'constants/companyNames';
import { isSuncareContext } from 'helpers/suncare/suncare';

const company = getCompany();
const isOneill = company === 'oneill';
const isSunshine = company === 'sunshine';

export default function TransferTypeSelector({
  handleChangeAppointedType,
  formData,
  carrierName = ''
}) {
  const isSuncareCarrier = isSuncareContext(carrierName);
  const transferOptions = isSuncareCarrier
    ? [TRANSFER_TYPES.NewAppointment]
    : TRANSFER_OPTIONS;

  return (
    <>
      {isSunshine && !isSuncareCarrier && (
        <p className='text-left leading-tight'>
          Please select your appointment type:
        </p>
      )}
      {isSuncareCarrier && (
        <p className='text-left leading-tight mb-3'>
          Appointment type: <strong>New Appointment</strong>
        </p>
      )}
      {!isSuncareCarrier && (
        <Stack spacing={5} sx={{ width: '100%', mb: 3, mt: 2 }}>
          {isSunshine && !isSuncareCarrier ? (
            <FormControl component='fieldset' sx={{ width: '100%' }}>
              <RadioGroup
                name='appointed-type'
                value={formData.appointedType}
                onChange={handleChangeAppointedType}
                sx={{ gap: 2 }}
              >
                {transferOptions.map(option => (
                  <FormControlLabel
                    key={option}
                    value={option}
                    control={<Radio />}
                    label={option}
                    sx={{
                      alignItems: 'center',
                      ml: 0,
                      '& .MuiFormControlLabel-label': {
                        whiteSpace: 'normal'
                      }
                    }}
                  />
                ))}
              </RadioGroup>
            </FormControl>
          ) : (
            !isSuncareCarrier && (
              <AutocompleteInput
                disableSearch
                value={formData.appointedType}
                label='Select Transfer Type (if applicable)'
                placeholder='Select Transfer Type (if applicable)'
                options={TRANSFER_OPTIONS}
                onValueChanges={event =>
                  handleChangeAppointedType({
                    target: { value: event.target.value }
                  })
                }
                helperText={
                  isOneill
                    ? ''
                    : `***Only select if you already have a carrier appointment but need to
            move it to ${companyNames.fullName}.`
                }
              />
            )
          )}
        </Stack>
      )}
    </>
  );
}

TransferTypeSelector.propTypes = {
  handleChangeAppointedType: propTypes.func.isRequired,
  formData: propTypes.object.isRequired,
  carrierName: propTypes.string
};
